import { render, staticRenderFns } from "./zzjsbmztdxmbllc.vue?vue&type=template&id=9800954a&scoped=true"
import script from "./zzjsbmztdxmbllc.vue?vue&type=script&lang=js"
export * from "./zzjsbmztdxmbllc.vue?vue&type=script&lang=js"
import style0 from "./zzjsbmztdxmbllc.vue?vue&type=style&index=0&id=9800954a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9800954a",
  null
  
)

export default component.exports